import { observer } from 'mobx-react-lite';
import { useComputed } from 'owa-react-hooks/lib/useComputed';
import { IOverflowSetItemProps, OverflowSet } from '@fluentui/react/lib/OverflowSet';
import { AriaProperties, AriaRoles, generateDomPropertiesForAria } from 'owa-accessibility';
import { getAllModuleSwitcherItems } from 'owa-left-rail-utils';
import { Module } from 'owa-bootstrap';
import * as React from 'react';
import { getOfficeAppItem, getAllOfficeAppItems } from 'owa-left-rail-utils';
import LeftRailItem from './LeftRailItem';
import OverflowButton from './OverflowButton';

export interface OfficeAppRailProps extends React.HTMLAttributes<HTMLAnchorElement> {
    containerWidth: number;
}

export const OfficeAppRail = observer(function OfficeAppRail(props: OfficeAppRailProps) {
    const officeAppItems_0 = useComputed((): IOverflowSetItemProps[] => {
        const maxNumButtons = maxNumButtons_0.get();
        const officeAppItems = getAllOfficeAppItems(true);

        // If the left nav can fit more icons than available office icons
        // fill with placeholder 'buttons' to match the number of module switcher items
        while (
            maxNumButtons > officeAppItems.length &&
            officeAppItems.length < getAllModuleSwitcherItems(Module.Mail).length
        ) {
            officeAppItems.push(getOfficeAppItem('Placeholder', '', true));
        }
        return officeAppItems;
    });
    const maxNumButtons_0 = useComputed((): number => {
        // Get the number of buttons that fit within container (minus the overflow button width)
        return Math.floor(props.containerWidth / 48 /* moduleButtonSize */);
    });
    const renderItem = (item: IOverflowSetItemProps) => {
        return (
            <LeftRailItem
                iconProps={item.iconProps}
                item={item.app}
                text={item.text}
                isSelected={false}
                isHorizontal={true}
                href={item.href}
                onClick={item.onClick}
                disabled={item.app === 'Placeholder'}
                openInNewTab={item.openInNewTab}
            />
        );
    };
    const containerAriaProps: AriaProperties = {
        role: AriaRoles.menubar,
        orientation: 'vertical',
    };
    let buttonsToShow = officeAppItems_0.get();
    const maxNumButtons = maxNumButtons_0.get();
    let overflowItems: IOverflowSetItemProps[] = [];
    if (maxNumButtons < officeAppItems_0.get().length) {
        // Subtract 1 to account for the overflow button
        buttonsToShow = officeAppItems_0.get().slice(0, maxNumButtons - 1);
        overflowItems = officeAppItems_0.get().slice(maxNumButtons - 1);
    }

    return officeAppItems_0.get().length === 0 ? null : (
        <OverflowSet
            vertical={false}
            items={buttonsToShow}
            overflowItems={overflowItems}
            onRenderItem={renderItem}
            onRenderOverflowButton={renderOverflowItem}
            {...generateDomPropertiesForAria(containerAriaProps)}
            styles={{
                root: { minWidth: props.containerWidth },
                item: { flex: '1 1 auto' },
            }}
        />
    );
});

function renderOverflowItem(overflowItems: IOverflowSetItemProps[]) {
    return <OverflowButton overflowItems={overflowItems} />;
}
